<template>
  <div class="order-success">
    <div class="success-top">
      <p>Thank You</p>
      <h1>Your Order is now Complete</h1>
    </div>

    <h5>You can save your voucher using the buttons below.</h5>
    <div class="btn-holder">
      <div class="text-right mt-4">
        <b-overlay
          :show="formStore.downloading['download']"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-flex"
        >
          <b-button
            variant="primary"
            size="lg"
            class="download-btn"
            @click="processVoucher('download')"
          >
            <i class="bi bi-download me-2" />
            Download
          </b-button>
          <b-button
            variant="secondary"
            size="lg"
            class="home-btn"
            @click="$router.push('/' + $route.params.storeId)"
          >
            <i class="bi bi-house me-2" />
            Home
          </b-button>
        </b-overlay>
      </div>
      <!-- <div class="text-right">
        <b-overlay
          :show="formStore.downloading['open']"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button
            variant="primary"
            size="lg"
            class="open-btn"
            @click="processVoucher('open')"
          >
            <i class="bi bi-folder2-open me-2" />
            Open
          </b-button>
        </b-overlay>
      </div> -->
    </div>
    <!-- <div class="wallet-btns">
      <div class="flex gap-4">
        <b-button class="add-to-apple">
          <img
            src="../images/Add_to_Apple_Wallet_badge.svg"
            alt="Apple Wallet"
          >
        </b-button>
        <b-button class="add-to-google">
          <img
            src="../images/Add_to_Google_Wallet_badge.svg"
            alt="Google Wallet"
          >
        </b-button>
      </div>
    </div> -->
  </div>
</template>
<script>
import { useFormStore } from "../stores/formStore";

export default {
  data() {
    return {
      formStore: useFormStore(),
    }
  },
  methods: {

    processVoucher(processType){
      const voucherNo = this.$route.params.voucherNo
      
      this.formStore.downloadVoucher(processType, voucherNo)
    }
  }
};
</script>

<style scoped>
.order-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: auto;
  border: 15px solid #f7f8fb;
  box-shadow: 0px 0px 29px -13px rgba(0, 0, 0, 0.75);
  border-radius: 15px;
  padding-bottom: 40px;
}
.btn-holder {
  display: flex;
  gap: 5px;
  flex-direction: column;
  align-items: center;
}
p {
  font-size: 26px;
  text-align: center;
  color: #4e5b6a;
  font-weight: 500;
}
h1 {
  font-size: 52px;
  font-weight: 600;
  text-align: center;
  color: #4e5b6a;
}
h5 {
  text-align: center;
  padding-top: 30px;
  color: #4e5b6a;
  max-width: 375px;
}
.success-top {
  background-image: url("/src/images/order-bg.png");
  background-size: cover;
  background-position: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 30px 0;
  width: 100%;
}
.download-btn {
  background-color: #27AE60 !important;
  border: none;
  color: white;
  padding: 7px 20px !important;
  font-size: 16px;
  cursor: pointer;
  width: 160px;
}
.home-btn {
  background-color: #0d6efd !important;
  border: none;
  color: white;
  padding: 7px 20px !important;
  font-size: 16px;
  cursor: pointer;
  width: 160px;
}
.open-btn {
  background-color: transparent !important;
  border: none;
  color: #27AE60;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500 !important;
}
.wallet-btns {
  display: flex;
  padding-top: 25px;
}
.add-to-apple{
  width: 170px;
  height: 50px;
  background: transparent !important;
  border: none;
}
.add-to-google{
  width: 170px;
  height: 50px;
  background: transparent !important;
  border: none;
  margin-left: 15px;
}
.btn-holder .b-overlay-wrap{
  gap: 10px;
}
@media (max-width: 1200px) {
  .order-success {
    width: 95%;
    padding-bottom: 30px;
  }
  h1 {
    font-size: 38px;
  }
  p {
    font-size: 20px;
  }
  h5 {
    font-size: 16px;
    max-width: 90vw;
  }
  .download-btn,
  .home-btn {
    width: 130px;
    font-size: 14px;
    padding: 7px 10px !important;
  }
  .add-to-apple,
  .add-to-google {
    width: 140px;
    height: 40px;
  }
}
</style>
